window.updatePagination = function(currentPageIndex) {
	const catalogPagination = document.querySelector('.catalog__pagination');
	if (!catalogPagination) return;

	const paginationItems = catalogPagination.querySelectorAll('.catalog__pagination-item');
	const paginationButtonNext = catalogPagination.querySelector('.catalog__pagination-item-next');
	const paginationButtonPrev = catalogPagination.querySelector('.catalog__pagination-item-previous');
	const currentItem = catalogPagination.querySelector(`li[data-pagination-page="${currentPageIndex}"]`);
	const nextItem = catalogPagination.querySelector(`li[data-pagination-page="${currentPageIndex+1}"]`);
	const prevItem = catalogPagination.querySelector(`li[data-pagination-page="${currentPageIndex-1}"]`);

	paginationItems.forEach(item => item.style.display = 'none');

	let firstPaginationItem = paginationItems[0];

	let lastPaginationItem = paginationItems[paginationItems.length - 1];
	lastPaginationItem.style.display = "flex";

	let startPage;
	let endPage;

	if (window.innerWidth < 768) {
		startPage = Math.max(currentPageIndex - 1, 1);
		endPage = Math.min(currentPageIndex + 1, lastPaginationItem.dataset.paginationPage);
	} else {
		startPage = Math.max(currentPageIndex - 2, 1);
		endPage = Math.min(currentPageIndex + 5, lastPaginationItem.dataset.paginationPage);
	}

	for (let i = startPage; i <= endPage; i++) {
		const visiblePaginationItem = catalogPagination.querySelector(`li[data-pagination-page="${i}"]`);
		visiblePaginationItem.style.display = 'flex';
	}

	if (endPage + 1 < lastPaginationItem.dataset.paginationPage) {
		const beforeLastVisibleItem = catalogPagination.querySelector(`li[data-pagination-page="${endPage}"]`)
			.getElementsByTagName('a')[0];
		if (beforeLastVisibleItem) {
			beforeLastVisibleItem.textContent = '...';
			beforeLastVisibleItem.style.display = 'flex';
		}
	}

	if (currentItem) {
		paginationItems.forEach(item => item.classList.remove('catalog__pagination-item-current'));
		currentItem.classList.add('catalog__pagination-item-current');
	}

	if (nextItem) paginationButtonNext.onclick = nextItem.querySelector('a').onclick;

	if (prevItem) paginationButtonPrev.onclick = prevItem.querySelector('a').onclick;

	if (currentPageIndex == lastPaginationItem.dataset.paginationPage) {
		if (paginationButtonNext) {
			paginationButtonNext.style.display = 'none';
		}
	}

	if (currentPageIndex == firstPaginationItem.dataset.paginationPage) {
		if (paginationButtonPrev) {
			paginationButtonPrev.style.display = 'none';
		}
	}
};
